/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { CarpsaleManagementSyncItemResponse } from './CarpsaleManagementSyncItemResponse';

export type CarpsaleManagementSyncItemResponseApiRespoonse = {
    data?: CarpsaleManagementSyncItemResponse;
    status?: CarpsaleManagementSyncItemResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace CarpsaleManagementSyncItemResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

